module.exports = __webpack_public_path__ + "img/luck-draw-banner.cc091238.jpg";